import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Spinner,
} from "reactstrap"
import { Form, ErrorMessage, Field, Formik } from "formik"
import Breadcrumbs from "components/Common/Breadcrumb"
import BackButton from "components/Shared/BackButton"
import { useLocation, useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { showAlert } from "store/reducers/alertReducer"
import Spinners from "components/Shared/Spinners"
import { addAllergenSchema } from "components/Common/validation"
import {
  addAllergen,
  getAllergenDetails,
  updateAllergen,
} from "store/actions/allergensAction"
import isPermissionEnabled from "common/isPermissionEnabled"
import {
  getImagePreviewSrc,
  handleFileChange2,
} from "components/Shared/fileHandlers"
import { useTranslation } from "react-i18next"
import TextError from "components/Shared/TextError"

const initialValues = {
  name: "",
  nameAr: "",
  imageUrl: "",
  imageType: "UPLOAD",
  status: true,
  imageFile: "",
}

const AddAllergen = ({ mode }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = `${mode === "add" ? t("Add") : t("Edit")} ${t(
    "Allergen | Sign Burger"
  )}`

  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const { loading, isLoading, allergenDetails } = useSelector(
    state => state.Allergens
  )
  const [formValues, setFormValues] = useState(initialValues)

  const { userRole, accountType } = useSelector(state => state.Login)
  const { isImageCompressing } = useSelector(state => state.Common)

  useEffect(() => {
    const isPermissionCreate = isPermissionEnabled(
      userRole,
      24,
      "allergen_2",
      accountType
    )
    const isPermissionEdit = isPermissionEnabled(
      userRole,
      24,
      "allergen_3",
      accountType
    )

    if (mode === "add") {
      if (!isPermissionCreate) {
        navigate("/dashboard")
      }
    } else if (mode === "edit") {
      if (!isPermissionEdit) {
        navigate("/dashboard")
      }
    }
  }, [])

  // IF HAVE MODE===EDIT THEN UPDATE INITAIL VALUES
  useEffect(() => {
    if (mode === "edit") {
      getOldValues()
    }
  }, [])

  const getOldValues = () => {
    const payload = {
      id,
    }
    dispatch(getAllergenDetails(payload))
  }

  // GET OLD VALUES WHEN HAVE
  useEffect(() => {
    if (allergenDetails && !loading && mode === "edit") {
      const { _id, name, nameAr, imageUrlType, imageUrl, status } =
        allergenDetails

      setFormValues({
        ...formValues,
        name,
        nameAr,
        imageType: imageUrlType,
        imageUrl,
        status: status === 1 ? "true" : false,
      })
    }
  }, [allergenDetails])

  const handleOnSubmit = values => {
    const { name, nameAr, imageUrl, imageType, status, imageFile } = values

    let data = new FormData()
    data.append("name", name)
    data.append("nameAr", nameAr)
    data.append("imageUrl", imageUrl)
    data.append("imageUrlType", imageType)
    // data.append("status", status ? 1 : 0)
    data.append("image", imageFile)

    if (mode === "add") {
      dispatch(addAllergen(data))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
            navigate(`/allergens`)
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    } else if (mode === "edit") {
      data.append("id", id)
      dispatch(updateAllergen(data))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
            navigate(`/allergens`)
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    }
  }

  if (mode === "edit" && loading) return <Spinners />

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col xl={12}>
            <Card>
              <CardBody>
                <CardTitle className="mb-2 d-flex align-items-center">
                  <BackButton />
                  {mode === "add" ? t("Add") : t("Edit")} {t("Allergen")}
                </CardTitle>
                <Formik
                  initialValues={formValues}
                  enableReinitialize={true}
                  validationSchema={addAllergenSchema(mode)}
                  onSubmit={handleOnSubmit}
                >
                  {({ values, setFieldValue, errors, touched }) => (
                    <Form>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="name">
                              <span className="text-danger">*</span>{" "}
                              {t("Name(English)")}
                            </label>
                            <Field
                              type="text"
                              id="name"
                              name="name"
                              placeholder={t("Name(English)")}
                              className={`form-control ${
                                touched.name && errors.name ? "is-invalid" : ""
                              }`}
                            />
                            {/* {console.log(errors)} */}
                            <TextError name="name" />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="nameAr">
                              <span className="text-danger">*</span>{" "}
                              {t("Name(عربي)")}
                            </label>
                            <Field
                              type="text"
                              id="nameAr"
                              name="nameAr"
                              placeholder={t("Name(عربي)")}
                              className={`form-control ${
                                touched.nameAr && errors.nameAr
                                  ? "is-invalid"
                                  : ""
                              }`}
                              style={{ direction: "rtl" }}
                            />
                            <TextError name="nameAr" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="imageType">{t("Image Type")}</label>
                            <Field
                              as="select"
                              id="imageType"
                              name="imageType"
                              className={`form-control ${
                                touched.imageType && errors.imageType
                                  ? "is-invalid"
                                  : ""
                              }`}
                              onChange={e => {
                                const selectedValue = e.target.value
                                setFieldValue("imageType", selectedValue)
                                // Reset the value of imageUrl and image when the image type changes
                                setFieldValue("imageUrl", "")
                                setFieldValue("imageFile", null)
                              }}
                            >
                              <option value="URL">{t("Image Url")}</option>
                              <option value="UPLOAD">
                                {t("Upload Image")}
                              </option>
                            </Field>
                            <TextError name="imageType" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            {/* IMAGE URL */}
                            {values.imageType === "URL" && (
                              <div className="form_field">
                                <label htmlFor="imageUrl">{t("URL")}</label>
                                <Field
                                  type="text"
                                  id="imageUrl"
                                  name="imageUrl"
                                  className={`form-control ${
                                    touched.imageUrl && errors.imageUrl
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                />
                                <TextError name="imageUrl" />
                              </div>
                            )}
                            {/* UPLOAD IMAGE */}
                            {values.imageType === "UPLOAD" && (
                              <div className="form_field position-relative">
                                <label htmlFor="imageFile">
                                  {t("Upload Image")}
                                </label>
                                <input
                                  type="file"
                                  id="imageFile"
                                  name="imageFile"
                                  accept="image/jpeg, image/jpg, image/png"
                                  onChange={e => {
                                    handleFileChange2(
                                      e,
                                      "imageFile",
                                      setFieldValue
                                    )
                                  }}
                                  className={`form-control ${
                                    touched.imageFile && errors.imageFile
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                />
                                {isImageCompressing && (
                                  <Spinner
                                    color="primary"
                                    className="file_upload_btn"
                                  />
                                )}
                                <TextError name="imageFile" />
                              </div>
                            )}
                            {getImagePreviewSrc(mode, values) && (
                              <div className="mt-3">
                                <img
                                  src={getImagePreviewSrc(mode, values)}
                                  alt="Preview"
                                  className="img_preview"
                                />
                              </div>
                            )}
                          </div>
                        </div>
                        {/* <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="status">Status</label>
                            <Switch
                              isChecked={values.status}
                              onClickHandler={() => {
                                setFieldValue("status", !values.status)
                              }}
                            />
                          </div>
                        </div> */}
                        <div className="mt-3"></div>
                        <div className="col-12 d-flex justify-content-end">
                          <Button
                            type="button"
                            className="mx-2"
                            color="secondary"
                            onClick={() => navigate(-1)}
                          >
                            {t("Cancel")}
                          </Button>
                          <Button
                            type="submit"
                            color="success"
                            disabled={isLoading || isImageCompressing}
                            className="w_fit_content"
                          >
                            {mode === "add" ? t("Add") : t("Save")}
                          </Button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default AddAllergen
